/* eslint-disable react-hooks/exhaustive-deps */

import { useAuth } from "context/AuthContext";
import { Outlet } from "react-router";
import { UserInfo } from "components/user-info";

import "./styles.scss";
import { NavLink } from "react-router-dom";
import { NavMenu } from "components/navmenu";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useModal } from "context/ModalContext";
import { getObjetivo } from "services/objetivo.service";
import { RegulamentoFooter } from "components/regulamento-footer";

import { func } from "prop-types";

export function Objetivos() {
  const { user } = useAuth();
  const { showModal } = useModal();
  const [objetivo, setObjetivo] = useState<any>();

  useEffect(() => {
    if (user) {
      // console.log(user.challenges);
      const completed = user.extra.avatar || user.image;
      if (!completed) {
        showModal("avatar-challenge");
      }

      getObjetivo().then(function (data) {
        setObjetivo(data[0]);
      });
    }
  }, [user]);

  if (!user) return null;

  return (
    <>
      <Helmet>
        <title>CONTA COMIGO 2026</title>
      </Helmet>
      <div id="home-wrapper" className="min-h-screen">
        <div className="z-10 relative flex flex-col items-center space-y-0">
          <div className="w-full flex flex-col items-center z-40">
            <NavMenu />

            <UserInfo />
          </div>
          <div className="w-screen m-0" id="objetivo">
            <div className="">
              {objetivo && (
                <>
                  {/* <h2 dangerouslySetInnerHTML={{ __html: objetivo.title }}></h2> */}
                  <div
                    className="w-full"
                    dangerouslySetInnerHTML={{ __html: objetivo.html }}
                  ></div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="bg-[#081c5a]">
          <RegulamentoFooter />
        </div>
      </div>
      <Outlet />
    </>
  );
}
